import * as React from 'react';
import { UIHeading1 } from '@cian/ui-kit';

import { Title } from '../AddPostFormFields';
import * as s from './AddPostForm.css';

export interface IAddQuestionFormParams {
  title: string;
}

/**
 * Форма добавления/редактирования вопроса
 */
export const AddQuestionForm = ({ title }: IAddQuestionFormParams) => {
  const titleProps = {
    value: 'Title',
    errorMessage: '',
    disabled: false,
    required: false,
    onChange: () => {},
  };

  return (
    <div className={s['wrapper']}>
      <UIHeading1>{title}</UIHeading1>
      <Title {...titleProps} />
    </div>
  );
};
